module.exports = __webpack_public_path__ + "img/shipping_bus.b83056c9.png";